"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCancellationPolicyWithHighestDeadline = void 0;
const selectCancellationPolicyWithHighestDeadline = (policies) => {
    // Check if the policies array is empty
    if (policies.length === 0)
        return undefined;
    // Initialize variables to track the selected policy and its maximum deadline days
    let selectedPolicy = undefined;
    let maxDeadlineDays = 0;
    let maxPenalty = 0;
    policies.forEach((policy) => {
        // Find the penalty with the highest deadline_days for the current policy
        const maxDeadlinePolicy = policy.penalties.reduce((prev, current) => {
            if (prev.deadline_days > current.deadline_days)
                return prev;
            if (prev.deadline_days === current.deadline_days &&
                prev.penalty > current.penalty)
                return prev;
            return current;
        }, policy.penalties[0]);
        // Compare with the current maximum and update if necessary
        if (maxDeadlinePolicy.deadline_days > maxDeadlineDays ||
            (maxDeadlinePolicy.deadline_days === maxDeadlineDays &&
                maxDeadlinePolicy.penalty > maxPenalty)) {
            maxDeadlineDays = maxDeadlinePolicy.deadline_days;
            maxPenalty = maxDeadlinePolicy.penalty;
            selectedPolicy = policy;
        }
    });
    return selectedPolicy;
};
exports.selectCancellationPolicyWithHighestDeadline = selectCancellationPolicyWithHighestDeadline;
